import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import equal from "fast-deep-equal";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ScenarioSelect from "components/Project/ScenarioSelect";

const getId = (props) =>
  props && props.reportId
    ? props.reportId
    : props && props.match && props.match.params && props.match.params.reportId
      ? props.match.params.reportId
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getBlueprintId = (props) =>
  props && props.blueprintId
    ? props.blueprintId
    : props && props.match && props.match.params && props.match.params.blueprintId
      ? props.match.params.blueprintId
      : undefined;

class ScenarioSelectContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <ScenarioSelect {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const projectId = ownProps.projectId;

  return {
    deploy: () => dispatch(projectReducer.deploy(projectId, true)),
    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(projectId, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(projectId)),

    saveScenario: (projectId, name) => dispatch(projectReducer.saveScenario(projectId, name))
  };
};
const mapStateToProps = (state, ownProps) => {
  const projectId = ownProps.projectId;

  const runId = projectReducer.getInnerId(state, projectId);

  return {
    runId: runId,
    projectId: projectId,

    hasSameScenario: projectReducer.getHasSameScenario(state, projectId, true),

    selectedScenario: projectReducer.getSelectedScenario(state, projectId),
    allScenarios: projectReducer.getAllScenarios(state, projectId),
    approvedScenario: projectReducer.getApprovedScenario(state, projectId, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ScenarioSelectContainer);
